import { render, staticRenderFns } from "./PublicUserProfile.vue?vue&type=template&id=2c5174ad&scoped=true&"
import script from "./PublicUserProfile.vue?vue&type=script&lang=js&"
export * from "./PublicUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PublicUserProfile.vue?vue&type=style&index=0&id=2c5174ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5174ad",
  null
  
)

export default component.exports